import { ReactNode, useId } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  children?: ReactNode;
  className?: string;
  headline?: string;
  title?: string | ReactNode;
  headerContent?: ReactNode;
  hideHeader?: boolean;
  testId?: string;
};
/**
 * @see For page subsections, use the PageSection component instead of Card to maintain proper heading hierarchy and accessibility.
 * @todo Refactor to make this more a traditional card component and less of a page section component.
 * @todo Will combine functionality from the CardSection component into this and remove the CardSection component.
 *
 */
export default function Card({
  children,
  className,
  headline,
  title,
  headerContent,
  testId,
  hideHeader = false,
}: Props) {
  const headlineId = useId();

  return (
    <section
      data-testid={testId}
      aria-labelledby={headline ? headlineId : ''}
      className={twMerge(
        'flex flex-col gap-6 rounded-md bg-surface-container-lowest p-4 shadow-xs md:p-8',
        className,
      )}
    >
      {(headline || title || headerContent) && (
        <header className={hideHeader ? 'sr-only' : undefined}>
          {headline && (
            <div
              className={twMerge(
                headerContent && 'grid gap-2 sm:grid-cols-[max-content_1fr]',
              )}
            >
              <h2
                id={headlineId}
                className={twMerge(
                  'text-left heading-sm text-on-surface',
                  headerContent && 'order-last sm:order-first',
                )}
              >
                {headline}
              </h2>
              {headerContent}
            </div>
          )}
          {title && <p className="text-on-surface-variant">{title}</p>}
        </header>
      )}
      {children}
    </section>
  );
}
